import { render, staticRenderFns } from "./TabButton.vue?vue&type=template&id=9b8786a0&"
import script from "./TabButton.vue?vue&type=script&lang=ts&"
export * from "./TabButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports